import { CurrentPayPlan, FlowType, MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import { NewJoinSessionData } from '../application/models/NewJoinSessionData';
import { FlowContentName, getFlowContent } from './getFlowContent';
import { benefitsHelper } from './benefitsHelper';

export class stringHelper {
  static formatMoney(value: string): string {
    let numericValue: number = parseFloat(value); // Convert string to number
    if (Number.isNaN(numericValue)) {
      return '';
    }
    let formattedString: string = numericValue.toFixed(2); // Format with two decimal places
    return `$${formattedString}`;
  }

  static getKeyFromEnum(targetEnum: object, key: string): string {
    return Object.keys(targetEnum)[Object.values(targetEnum).indexOf(key)];
  }
}

export const promotionalLabelMap = {
  [MembershipLevel.CLASSIC]: 'Essential',
  [MembershipLevel.CLASSIC_RV]: 'Essential',
  [MembershipLevel.PLUS]: 'Best value',
  [MembershipLevel.PLUS_RV]: 'Best value',
  [MembershipLevel.PREMIER]: 'Most exclusive',
  [MembershipLevel.PREMIER_RV]: 'Most exclusive',
};

export const benefitListTitleMap = {
  [MembershipLevel.CLASSIC]: 'Essential benefits for the road and beyond',
  [MembershipLevel.CLASSIC_RV]: 'Essential benefits for the road and beyond',
  [MembershipLevel.PLUS]: 'All the benefits of Classic, and:',
  [MembershipLevel.PLUS_RV]: 'All the benefits of Classic, and:',
  [MembershipLevel.PREMIER]: 'All the benefits of Classic and Plus, and:',
  [MembershipLevel.PREMIER_RV]: 'All the benefits of Classic and Plus, and:',
};

export const getMembershipTitle = (membershipLevel: MembershipLevel) => {
  switch (membershipLevel) {
    case MembershipLevel.CLASSIC:
      return 'Classic';
    case MembershipLevel.PLUS:
      return 'Plus';
    case MembershipLevel.PREMIER:
      return 'Premier';
    default:
      return '';
  }
};

export const getRecurringPeriodLabel = (sessionData: NewJoinSessionData, isMonthlySelected?: boolean) => {
  const discountApplied = benefitsHelper.discountApplied(sessionData?.priceCart);
  const ERSApplied = benefitsHelper.ERSApplied(sessionData?.priceCart);

  //MDO
  if (
    //switching mdo/ado on landing page
    isMonthlySelected ||
    (isMonthlySelected === undefined && sessionData.formData.billPlan === CurrentPayPlan.RECURRINGMONTHLY)
  ) {
    return getFlowContent(FlowContentName.MDOLabel, sessionData.flowType, sessionData.clubCode!);
  } else if (
    //annual
    discountApplied ||
    //discounted
    ERSApplied ||
    //gift flow
    sessionData.flowType === FlowType.GIFT
  ) {
    return getFlowContent(FlowContentName.ADODiscountedLabel, sessionData.flowType, sessionData.clubCode!);
  } else {
    return getFlowContent(FlowContentName.ADOLabel, sessionData.flowType, sessionData.clubCode!);
  }
};
